import adminApi from '../admin';
import { SIGN_OUT } from '../../store/types';
import { FORBIDDEN_STATUS } from '../../utils/constants';

export const adminInterceptor = (store) => {
  adminApi.interceptors.response.use(
    (res) => res,
    (error) => {
      const {
        response: { status },
      } = error;
      if (status === FORBIDDEN_STATUS) {
        localStorage.removeItem('token');
        store.dispatch({ type: SIGN_OUT });
      }
      return Promise.reject(error);
    },
  );
};
